export default String.raw`
.product-presentation{
  margin: 30px 9%;
  &__top-section{
    display: grid;
    grid-template-columns: 40% calc(60% - 20px);
    grid-template-rows: 90px auto;
    column-gap: 20px;
    .gallery-container{
      grid-column: 1 / 2;
      grid-row: 1 / 3;
      position: relative;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      &__flags{
        position: absolute;
        top: 16px;
        left: 8px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        z-index: 1;
      }
    }
    .product-name-container{
      grid-column: 2 / 3;
      grid-row: 1 / 2;
      &__product-name{
        font-size: 18px;
        font-weight: 600;
        line-height: 24px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &__buttons-container{
        display: flex;
        justify-content: flex-end;
        margin: 14px 0;
        border-bottom: 1px solid #E7E7E7;
        &.two-columns{
          justify-content: space-between;
        }
        .product-code-and-availability-container {
          padding: 20px 0 16px;
        }
        .product-code{
          font-size: 14px; 
          line-height: 20px; 

          svg {
            position: relative;
            z-index: 2;
            vertical-align: sub;
            margin-left: 4px;
            cursor: pointer;
            fill: $primaryColor;
            pointer-events: all;
          }
        }
        .availability{
          display: flex;
          align-items: center;
          gap: 5px;
          padding-top: 5px;
          font-size: 12px;
          line-height: 16px;
          img{
            max-height: 16px;
          }
        }
        .buttons{
          display: flex;
          flex-shrink: 0;
          gap: 20px;
          align-items: flex-end;
          padding: 20px 0 16px;
          .pure-button{
            gap: 10px;
            &__icon{
              width: 24px;
              height: 24px;
            }
            &__text{
              font-weight: 600;
              font-size: 14px; 
              line-height: 20px; 
            }
          }
        }
      }
    }
    .main-content-container{
      grid-column: 2 / 3;
      grid-row: 2 / 3;
      padding-top: 20px;
      &.simple-product{
        display: flex;
        gap: 25px;
        justify-content: space-between;
        flex-direction: row-reverse;

        .buttons-container{
          display: block;
        }
        .main-content-container__attributes{
          display: block;
          margin: 0;
          border: none;
          padding: 0;
          .attribute{
            width: 100%;
            margin-top: 16px;
          }
          .pure-button{
            margin-top: 16px;
          }
        }
      }
      .prices-container{
        margin: 16px 0;
        display: flex;
        flex-direction: column;

        .customize {
          @include body-1-medium;
          margin-top: 16px;
          margin-bottom: 8px;
        }

        .name{
          @include body-2-medium;
        }

        &:has(.graphical-variants) {
          max-width: 450px;

          .last-level-attribute {
            width: max-content;

            &__more-attributes {
              margin: 16px 0;
            }
          }
        }
        
        .graphical-variants {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;

          &:has(.chip--default) {
            gap: 16px;
          }

          &__container {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-top: 16px;
          }

          &__attributes {
            margin-top: 16px;
            max-width: 280px;

            .attribute-editable {
                margin-right: 10px;
                vertical-align: top;
                &__name{
                  color: #2E2E2E;
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 16px;
                  display: block; 
                }
                input{
                  border-radius: 5px;
                  border: 1px solid #4A4A4A;
                  height: 42px;
                  font-size: 14px; 
                  line-height: 20px; 
                }
                .select__input{
                  border: 1px solid #4A4A4A;
                  border-radius: 5px;
                  padding: 10px;
                  min-height: 42px;
                }
                .select__options li{
                  white-space: normal;
                  font-size: 14px; 
                  line-height: 20px; 
                }
                .selected-js{
                  margin-right: 10px;
                  width: 200px;
                  white-space: nowrap;
                  font-size: 14px;
                  line-height: 20px;
                  text-overflow: ellipsis;
                }
                svg{
                  width: 15px;
                  height: 15px;
                }
              .form__input-wrapper {
                margin: 8px 0 20px;

                .select {
                  &__options {
                      position: fixed;
                      max-width: 247px;
                  }
                }
              }
            }
          }

          &__quantity-unit {
            display: flex;
            flex-direction: row;
            gap: 12px;
            flex-wrap: nowrap;
            align-items: center;
            margin-top: 12px;
          }

          .chip {
            position: relative;
            display: flex;
            width: 72px;
            height: 72px;
            justify-content: center;
            align-items: center;
            gap: 12px;
            border-radius: 6px;
            border: 1px solid #D5D5D5;
            cursor: pointer;

            &--color {
                width: 40px;
                height: 40px;
                aspect-ratio: 1/1;
                border-radius: 100%;
                border: none;
                padding: 0;

                .multicolor {
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  background: conic-gradient(
                    red,
                    yellow,
                    green,
                    cyan,
                    blue,
                    magenta,
                    red
                  );
                }
            }

            &--default {
              height: 40px;
              width: auto;
              padding: 10px 16px;
              justify-content: center;
              align-items: center;
              border-color: $primaryColor;
              color: $primaryColor;
              background-color: #fff;
              font-size: 14px;
              line-height: 20px; 
            }

            &--showMore {
              width: auto;
              height: auto;
              border: none;
            }

            input {
                position: absolute;
                opacity: 0;
                width: 0;
                height: 0;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                border-radius: 4px;
            }

            &:has(input:checked) {
                border: 2px solid $primaryColor;
                font-weight: 600;
            }
          }
        }

        &__login-to-see-prices{
          display: flex;
          align-items: center;
          gap: 10px;
          .icon{
            width: 19px;
            height: 19px;
          }
          .info{
            font-size: 14px; 
            line-height: 20px; 
          }
        }
        &__label{
          color: #767676;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 5px;
        }
        &__range{
          font-size: 14px; 
          line-height: 20px; 
        }
        &__open-thresholds-popup{
          color: #2E2E2E;
          font-weight: 400;
          text-decoration: underline;
          padding: 0;
          margin-top: 5px !important;
          font-size: 14px; 
          line-height: 20px; 
        }
        &__price-container{
          display: flex;
          gap: 8px;
          align-items: center;
          margin: 4px 0;
          .price{
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
          }
          .previous{
            font-size: 12px;
            line-height: 18px;
            color: #767676;
            text-decoration: line-through;
          }
          .label{
            font-size: 14px; 
            line-height: 20px;
            margin-bottom: unset;
          }
        }
        &__deposit-container {
          display: flex;
          gap: 8px;
          align-items: center;
          margin: 4px 0;
          .price {
            font-size: 12px;
            line-height: 18px;
            color: #767676;
          }
        }
        &__suggested {
          @include body-2-regular;
          height: 24px;
          padding: 8px 0;
          color: #767676;
        }
        &__default-unit-price-container {
          font-size: 12px;
          color: #767676;
          margin-bottom: 4px;
        }

        &__lowest-price{
          font-size: 12px;
          line-height: 16px;
          color: #767676;
          margin-top: 4px;
          margin-bottom: 16px;
        }
        &__unit-price{
          font-size: 12px;
          line-height: 16px;
          margin: 8px 0;
        }
        &__availability-container{
          font-size: 12px;
          line-height: 16px;
          &:nth-last-child(2){
            margin-bottom: 10px;
          }
          .availability{
            display: flex;
            align-items: center;
            gap: 5px;
          }
          img{
            max-height: 16px;
          }
        }
        &__stock-container{
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 10px;
          img{
            max-height: 16px;
            margin-top: 10px;
          }
          .stock{
            margin-top: 10px;
          }
        }
        &__quantity-container{
          .quantity.validation-error {
            border-color: $dangerColor;
            input {
              color: $dangerColor;
            }
          }
          display: flex;
          gap: 10px;
          align-items: center;
          .select{
            font-size: 14px;
            line-height: 20px;
            &__input{
              display: inline-flex;
              align-items: center;
              gap: 10px;
              justify-content: flex-start;
              border-bottom: 2px solid $primaryColor;
              padding: 0 16px 4px 8px;
              height: 20px;
              svg{
                transform: rotate(0deg);
                width: 15px;
                height: 15px;
                fill: $primaryColor;
              }
            }
          }
          .unit-container__unit-ratio-info{
            padding-left: 8px;
            font-size: 14px;
            .unit-ratio-info-js{
              line-height: 20px;
              display: block;
            }
          }
        }

        &__points-price {
          @include body-1-regular;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          gap: 8px;

          svg {
            width: 24px;
            height: 24px;
            fill: $primaryColorFont;
          }
        }
      }
      &:has(.graphical-variants) {
        .buttons-container {
          max-width: 478px;
          flex-direction: column;
        }
      }
      .buttons-container{
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        &__buttons{
          margin: 0 0 16px;

          .primary-buttons{
            display: flex;
            gap: 8px;
            margin-bottom: 8px;
          }
          .primary-action-button{
            display: inline-flex;
            gap: 5px;
            width: 100%;
            justify-content: center;
            &.with-wishlist{
              width: calc(100% - 50px);
            }
            &__text{
              font-weight: 600;
              line-height: 20px;
            }
            &__icon{
              width: 21px;
              height: 19px;
            }
          }
          .pure-button{
            display: inline-flex;
            gap: 5px;
            padding: 0;
            &__text{
              font-weight: 600;
              line-height: 20px;
            }
            &__icon{
              width: 21px;
              height: 19px;
            }
          }
          .secondary-buttons{
            display: flex;
            gap: 8px;
          }
          .secondary-action-button{
            padding: 8px 16px;
            
            &:last-child {
              flex: 1 0 auto;
            }

            &.wishlist{
              width: 40px;
              padding: 0;
            }
            &__icon{
              fill: $primaryColor;
              width: 24px;
              height: 24px;
            }
          }
          form:last-child{
            width: 100%;
            .secondary-action-button{
              width: 100%;
            }
          }
        }
        &__links{
          display: flex;
          flex-direction: column;
          gap: 16px;

          .pure-button {
            color: $primaryColorFont;
            text-decoration: underline;
            font-weight: normal;
            gap: 8px;
            &.delivery-cost-button{
              text-decoration: none;
              cursor: default;
              .delivery-cost-link {
                color: $primaryColorFont;
                text-decoration: underline;
              }
            }
            svg {
              fill: $primaryColorFont;
            }
          }

          .loyalty-info {
            @include body-1-regular;
            display: flex;
            align-items: center;
            gap: 8px;

            svg {
              width: 20px;
              height: 20px;
              fill: $primaryColorFont;
            }
          }
        }
      }
      &__attributes{
        margin-top: 24px;
        border-top: 1px solid #F3F3F3;
        padding-top: 25px;
        display: flex;
        flex-wrap: wrap;
        column-gap: 25px;
        row-gap: 15px;
        .attribute{
          width: calc((100% - 25px)/2);
          font-size: 14px; 
          line-height: 20px; 
        }
        .pure-button{
          svg {
            width: 15px;
            height: 15px;
          }
        }
        &.archival {
          border: none;
        }
      }
      .min-quantity-info {
        display: flex;
        column-gap: 8px;
        max-width: 250px;
        margin-top: 11px;
        @include body-2-regular;

        svg {
          min-width: 20px;
          min-height: 20px;
          width: 20px;
          height: 20px;
          fill: $warnColor;
        }

        &.phantom {
          margin-top: 0;
          max-width: 100%;
        }
      }
    }
  }
  
  .attributes{
    &__not-last-level-attribute, &__container{
      margin-top: 16px;
      .values{
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-top: 12px;
        .value{
          border: 1px solid $primaryColor;
          border-radius: 5px;
          padding: 10px 16px;
          color: $primaryColor;
          background-color: #fff;
          font-size: 14px; 
          line-height: 20px; 
          &.active-js{
            border: 2px solid $primaryColor;
            font-weight: 600;
          }
        }
      }
    }
    &__table-container{
      overflow: auto;
      white-space: nowrap;
      position: relative;
      margin-top: 24px;
      &.attr-poly-table-js tbody tr:hover{
        box-shadow: none;
      }
      table{
        border: none; 
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 8px;
        background: #fff;
      }
      thead{
        height: auto; 
        tr{
          background-color: #fff; 
          box-shadow: inset 0px -1px 0px 0px #F3F3F3;
          position: sticky;
          z-index: 2;
          top: 0;
        }
      }
      th{
        white-space: nowrap;
        font-weight: 500;
        font-size: 14px; 
        line-height: 20px; 
        &:first-child {
          z-index: 3;
          top: 0;
          border-bottom: 1px solid #f3f3f3;
        }
      }
      tbody{
        tr{
          cursor: pointer;
          box-shadow: inset 0px -1px 0px 0px #F3F3F3;
          background-color: #fff; 
          outline-offset: -1px !important;
          &:hover{
            .name-column{
              border-radius: 4px 0 0 4px;
            }
            .unit-column, .notify-about-availability-column{
              border-radius: 0 4px 4px 0;
            }
          }
          &.active-js{
            box-shadow: inset 0px 0px 0px 1px $primaryColor;
            border-radius: 4px;
            .name-column{
              border-top: 1px solid $primaryColor;
              border-bottom: 1px solid $primaryColor;
              border-left: 1px solid $primaryColor;
              border-radius: 4px 0 0 4px;
            }
            .unit-column, .notify-about-availability-column{
              border-radius: 0 4px 4px 0;
            }
          }
          .last-level-attribute {
            cursor: default;
          }
          &.attr-container-row {
            overflow: hidden;
            transition: height 0.4s ease;
              
            td {
              padding: 0 !important;
              .last-level-attribute {
                &__more-attributes {
                  width: fit-content !important;
                  .attr-container {
                    display: flex;
                    flex-direction: column;
                    width: fit-content;
                    .attribute-editable {
                      .form__input-wrapper {
                        margin: 8px 0 20px;

                        .select {
                          &__options {
                              position: fixed;
                              max-width: 247px;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .name-column{
          font-size: 12px;
          line-height: 16px;
          border-bottom: 1px solid #f3f3f3;
        }
      }
      td, th{
        padding: 8px;
        vertical-align: middle;
        text-align: left;
        &:last-child{
          padding-right: 0;
        }
      }
      .netto-price-column, .brutto-price-column{
        &__price {
            display: flex;
            font-weight: 600;
            font-size: 14px; 
            line-height: 20px;
            align-items: baseline;

            .price {
                margin: 0 4px;
            }
        }

        &__deposit-price {
            display: flex;
            font-weight: 400;
            font-size: 12px; 
            line-height: 20px; 
            color: #767676;

            .deposit, .deposit-js {
                margin-left: 4px;
            }
        }
        &__previous-price{
          display: inline-block;
          color: #767676;
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          text-decoration-line: line-through;
          margin-left: 8px;
        }
        &__unit-ratio-info{
          @include body-3-medium;
        }
        &__lowest-price{
          color: #767676;
          @include body-3-medium;
          width: auto !important; 
        }
        .pure-button {
          min-height: 40px;
        }
      }
      .thresholds-column{
        &__label{
          color: #767676;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 5px;
        }
        &__range{
          font-size: 14px; 
          line-height: 20px; 
        }
        &__open-thresholds-popup{
          color: #2E2E2E;
          font-weight: 400;
          text-decoration: underline;
          padding: 0;
          margin-top: 5px;
          font-size: 14px; 
          line-height: 20px; 
        }
      }
      .notify-about-availability-column{
        text-align: center;
        &__button{
          font-weight: 600;
          font-size: 14px; 
          line-height: 20px; 
        }
      }
      .last-level-attribute.with-attributes{
        border-bottom: none;
      }
      .attribute-editable{
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        &__name{
          color: #2E2E2E;
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
          display: block; 
        }
        input{
          border-radius: 5px;
          border: 1px solid #4A4A4A;
          height: 42px;
          font-size: 14px; 
          line-height: 20px; 
        }
        .select__input{
          border: 1px solid #4A4A4A;
          border-radius: 5px;
          padding: 10px;
          min-height: 42px;
        }
        .select__options li{
          white-space: normal;
          font-size: 14px; 
          line-height: 20px; 
        }
        .selected-js{
          margin-right: 10px;
          width: 200px;
          white-space: nowrap;
          font-size: 14px;
          line-height: 20px;
          text-overflow: ellipsis;
        }
        svg{
          width: 15px;
          height: 15px;
        }
      }
      .label.sign-in .label__text {
        display: inline-block;
        width: 100px;
        white-space: break-spaces;
      }
    }
    &__buttons{
      margin-top: 30px;
      text-align: right;
      .primary-action-button{
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 10px 20px;
        svg{
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .stock-column{
    .stock-column-data{
      display: flex;
      align-items: center;
      justify-content: left;
      gap: 8px;
      min-width: 110px;
      flex-wrap: wrap;
      img{
          max-height: 16px;
      }
      .stock{
          font-size: 12px;
          line-height: 16px;
      }
    }
  }
  .quantity-column .quantity{
    background: $inputsBgColor;
    border: 1px solid #767676;
    border-radius: 5px;
    display: inline-flex;
    width: 107px;
    height: 40px;
    padding: 10px;
    &__input{
      background: transparent;
      font-size: 14px; 
      line-height: 20px; 
      border: none;
      width: 49px;
      height: 18px;
      text-align: center;
    }
    &__minus, &__plus{
      background: transparent;
      border: none;
      width: 18px;
      padding: 0;
      .icon{
      width: 11px;
      height: 11px;
      fill: #959595;
      }
    }
    &.validation-error {
      border-color: $dangerColor;
      input {
        color: $dangerColor;
      }
    }
  }

  .unit-column{
    font-size: 14px; 
    line-height: 20px; 
    .select__input{
      display: inline-flex;
      align-items: center;
      gap: 10px;
      justify-content: flex-start;
      border-bottom: 2px solid $primaryColor;
      padding: 0 16px 4px 8px;
      svg{
        width: 15px;
        height: 15px;
        fill: $primaryColor;
      }
    }
    .select__options{
      width: auto;
      right: 0;
    }
    &__unit-ratio-info{
      padding: 4px 0 0 7px;
      height: 24px;
    }
    .select {
      width: fit-content;
    }
  }
  
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    img {
      border-radius: 8px;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.single-image {
  position: relative;
  width: 100%;
  padding: 0 25px;
  height: 429px;

  &.zoomed-js {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: 100vh !important;
    z-index: 9999;
    display: flex;
    align-items: center;
    background-color: $bgColor;

    .single-image__next {
      right: 20px;
    }

    .single-image__prev {
      left: 20px;
    }

    .swiper-slide {
      cursor: auto !important;
      padding: 25px;
    }
  }

  .close-popup {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 20px;
    height: 20px;
    z-index: 2;

    svg {
      width: 20px;
      height: 20px;
      fill: $btnSolidBgColor;
    }
  }

  &.with-no-image{
    height: 429px;
  }
  &__prev, &__next {
    position: absolute;
    z-index: 90;
    top: calc(50% - 24px);
    svg {
      width: 16px;
      height: 16px;
    }
  }
  &__swiper{
    width: 100%;
    height: 100%;

    &:focus-within {
      outline-style: solid;
      outline-color: $focusVisibleColor;
      outline-width: 1px;
      outline-offset: 2px;
    }
  }
  &__prev {
    left: 2px;
    svg {
      rotate: 180deg;
    }
  }
  &__next {
    right: 2px;
  }
  .swiper-slide {
      border-radius: 8px;
    cursor: pointer;
    img {
      max-height: 100%;
      width: fit-content;
      object-fit: contain;
      aspect-ratio: auto;
      border-radius: 8px;
    }
  }
  .swiper-pagination {
    display: none;
  }
  .no-image{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    fill: #D5D5D5;
  }
  .open360 {
    position: absolute;
    bottom: 0;
    left: 0;
    right: unset;
    top: unset;
    z-index: 1;
    background: rgba(255, 255, 255, 0.60);
    width: 40px;
    height: 40px;
    border-radius: 4px;
    padding: 4px !important;
  }
}

.multi-image {
  position: relative;
  margin-top: 15px;
  padding: 0 25px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  &__prev, &__next {
    position: absolute;
    display: none;
    z-index: 90;
    width: 32px;
    height: 32px;
    top: calc(50% - 16px);
    svg {
      width: 16px;
      height: 16px;
    }
  }
  &__prev {
    left: 2px;
    svg {
      rotate: 180deg;
    }
  }
  &__next {
    right: 2px;
  }
  &__swiper{
    height: 80px;
    box-sizing: border-box;
  }
  .swiper-slide {
    width: 20%;
    height: 100%;
    border-radius: 2px;
    cursor: pointer;
    outline-offset: -4px !important;

    img {
      display: block;
      width: 100%;
      height: 100%;
      aspect-ratio: auto;
      box-sizing: border-box;
      object-fit: contain;
      border-radius: 4px;
    }

    .video-tile {
      width: inherit;
      height: inherit;
      position: absolute;
      background-color: rgba(134, 134, 134, 0.7);

      &.youtube {

        background-color: transparent;
      }

      .play-video {
        width: 32px;
        height: 32px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        fill: #ffffff;
      }
    }


  }
  .swiper-slide-thumb-active {
    border: 1px solid #767676;
    border-radius: 4px;
  }
}
  
.popup {
  &__content {
    max-height: none;

    .form__product-name{
      @include body-1-medium;
      margin-bottom: 25px;
    }

    .ask-for-price-quantity {
      justify-content: flex-start;
      align-items: center;
      gap: 16px;

      .form {
        &__input {
          &-wrapper {
            width: auto;
          }
        }
      }

      .select__input {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        justify-content: flex-start;
        border-bottom: 2px solid $primaryColor;
        padding: 0 16px 4px 8px;
        
        svg {
          width: 15px;
          height: 15px;
          fill: $primaryColor;
        }
      }
    }
  }

  &__buttons {
    .primary-action-button{
        width: 256px;
        margin: 0 auto;
        align-items: center;
        gap: 4px;
        outline-offset: -1px !important;
    }
  }
}

.dropdown-supervisor {
  position: absolute;
  border-radius: 5px;
  background: #FFF;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.20);
  width: 400px;
  padding: 16px;
  z-index: 999;

  &__header {
    display: flex;
    justify-content: space-between;
    gap: 30px;
    padding-bottom: 16px;
  }
}

.supervisor {
  display: flex;
  gap: 16px;

  &__img {
    svg {
      width: 24px;
      height: 24px;
    }

    img {
      width: 52px;
      height: 52px;
      border-radius: 48px;
    }
  }

  &__title {
    display: flex;
    align-items: baseline;
    gap: 4px;

    .phone {
      @include body-2-regular;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &-details {
      @include body-2-regular;
      display: flex;
      align-items: center;
      gap: 4px;

      span, a {
        @include body-2-medium;
        color: $primaryColorFont;
      }
  
      svg {
        fill: #767676;
        margin-right: 4px;
      }
    }

    &-description {
      margin: 16px 0;
      @include body-1-regular;
    }
  }
}

.share-product{
  &.active-js{
    background-color: #F1DDDE;
    border-radius: 100px;
  }
}

.share-product-dropdown{
  position: absolute;
  z-index: 3;
  background-color: #fff;
  margin-top: 10px;
  border-radius: 5px;
  -webkit-box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 2px 0px 8px 0px rgba(0, 0, 0, 0.12);
  .dropdowns > *{
    display: flex;
    width: 100%;
    gap: 10px;
    cursor: pointer;
    padding: 10px 16px;
    color: #2E2E2E;
    &:hover{
      color: $primaryColor;
      svg{
        fill: $primaryColor;
      }
    }
  }
  svg{
    width: 24px;
    height: 24px;
    fill: #2E2E2E;
  }
}

.reviews-container {
  padding-top: 32px;
  border-top: 1px solid #D5D5D5;

  &__header {
    display: flex;
    gap: 24px;
    padding-top: 24px;
    justify-content: space-between;

    .no-reviews {
      @include h2-headline;
      display: flex;
      flex-direction: column;
      gap: 16px;
  
      span {
        width: max-content;
      }
    }

    .review-overall {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .all-opinions {
        @include h2-headline;
        display: flex;
        align-items: center;
        gap: 4px;

        span {
          @include body-1-regular;
        }
      }

      .stars {
        display: flex;
        height: 32px;
        gap: 16px;
        fill: #F5A623;
      }
    }

    &-subsection {
      display: flex;
      justify-content: space-between;
      gap: 24px;
      width: 100%;

      .reviews-summary {
        display: flex;
        align-items: flex-start;
        flex: 1 0 0;
        gap: 32px;
  
        &__star-details {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 8px;
          flex: 1 0 0;
  
          .opinion-counter {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          progress[value] {
            --color: #F5A623;
            --background: #F3F3F3;
          
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            border: none;
            width: 190px;
            height: 8px;
            flex-shrink: 0;
            border-radius: 10em;
            background: var(--background);
          }
          progress[value]::-webkit-progress-bar {
            border-radius: 10em;
            background: var(--background);
          }
          progress[value]::-webkit-progress-value {
            border-radius: 10em;
            background: var(--color);
          }
          progress[value]::-moz-progress-bar {
            border-radius: 10em;
            background: var(--color);
          }
          
          .review-bar {
            @include body-1-regular;
            display: flex;
            width: max-content;
            gap: 16px;
            justify-content: flex-start;
            align-items: center;
  
            &__number {
              min-width: 10px;
            }
  
            svg {
              flex-shrink: 0;
              fill: #767676;
            }
          }
        }
      }
    }
  }
  
  &__content {
    margin-top: 32px;

    .review {
      display: grid;
      grid-template-columns: 20% 1fr;
      padding-top: 24px;
      margin: 24px 0;
      gap: 24px;
      border-top: 1px solid #D5D5D5;

      &:last-of-type {
        margin: 0;
        border: none;
      }

      &__details {
        display: flex;
        width: 205px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 16px;
        line-height: 20px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
    
        .product-rating {
          display: flex;
          align-items: center;
          gap: 12px;
          align-self: stretch;
          font-weight: 600;
        }
    
        .verified-purchase {
          display: flex;
          align-items: center;
          gap: 8px;
          align-self: stretch;
          color: #008945;
          font-size: 14px;
          font-style: normal;
    
          svg {
            width: 24px;
            height: 24px;
            fill: #008945;
          }
        }
    
        .review-author {
          font-weight: 500;
          word-wrap: break-word;
        }
    
        .review-date {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
        }
      }
    
      &__content {
        display: flex;
        gap: 16px;
        flex-direction: column;

        .review-description {
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
          align-self: flex-start;
          overflow: hidden;
          position: relative;
          word-break: break-word;
          transition: max-height 0.3s ease-out;
        }

        .pure-button {
          align-self: flex-end;
        }
      }

      .more-review {
        -webkit-box-orient: unset !important;
        transition: 0.3s ease;
      }
    }    

    .download-more-reviews {
      display: flex;
      justify-content: center;
      margin-bottom: 24px;
    }

    .message-popup-background {
      padding: 5vw;
    }
  }
}

.no-reviews-js {
  display: flex;
  justify-content: space-between;
  max-height: 560px;
  gap: 24px;
  overflow: auto;
  padding-bottom: 32px;
}

.reviews {
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  gap: 16px;

  .description {
    display: flex;
    gap: 16px;
    align-items: center;
    .secondary-action-button {
      max-width: 200px;
    }
  }

  svg {
    align-self: baseline;
    flex-shrink: 0;
    fill: $secondaryColorFont;
  }

  .secondary-action-button {
    align-self: center;
    width: 70%;
  }
}

.not-auth {
  align-items: flex-start;
}

.auth {
  align-items: center;
}

.add-review {
  padding: 32px 16px 32px 32px;
  max-width: 700px;

  h3 {
    padding-bottom: 16px;
  }

  .review-content {
    display: flex;
    flex-direction: column;
    align-items: start;
    flex: 1 1 auto;
    overflow-y: auto;
    padding-right: 16px;
    width: 100%;
  }

  .product-container {    
    display: flex;
    align-items: center;
    gap: 16px;
    padding-bottom: 24px;

    .info {
      .name {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        white-space: normal;

        a {
          outline-offset: -1px !important;
        }
      }
    }

    .no-image {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      fill: $labelsColor;
    }

    .image {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      
      img {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        object-fit: contain;
      }
    }
  }

  .add-opinion {
    align-self: center;
    padding-right: 16px;
  }
}

.write-review {
  @include body-1-regular;
  padding: 24px 0;
}

.add-opinion {
  display: flex;
  justify-content: center;

  .primary-action-button {
    display: flex;
    width: 245px;
  }
}

.rating {
  display: flex;
  flex-direction: row-reverse;
  justify-content: start;

  .choose-rating-js {
    cursor: pointer;
  }

  .stars {
    width: 42px;
    height: 32px;
    padding-right: 8px;
    fill: #D5D5D5;

    &.reviewed {
      fill: #F5A623;
    }
  }

  .choose-rating-js:hover,
  .choose-rating-js:hover ~ .stars {
    fill: #F5A623 !important;
  }

  &:hover {
    .reviewed {
      fill: #D5D5D5;
    }
  }
}

.review-popup {
  height: 500px;
  overflow: auto;
}


.product-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  padding: 32px 0;
  border-top: 1px solid #D5D5D5;
}

.product-attributes {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  padding-top: 32px;

  .attributes-column {
    display: grid;
    grid-template-columns: 48% auto;
    align-items: center;
    column-gap: 64px;
    align-self: stretch;
    padding-bottom: 20px;

    > li {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 8px;
      padding: 12px 0;
      border-bottom: 1px solid #D5D5D5;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      .value {
        font-weight: 600;
      }
    }

    > li.odd-element:last-child:not(.hidden-js) {
      border-bottom: none;
    }
  }
}

.gpsr-container-js {
  border-top: 1px solid #D5D5D5;
  
  h2 {
    padding-top: 24px;
  }
}

.gpsr {
  @extend .product-attributes;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  .attributes-column {
    display: block;

    h3 {
      padding-bottom: 12px;
    }
  }

  .single-view {
    display: grid;
  }
}

.grid-view {
  grid-template-columns: repeat(1, 1fr);
}

.downloads {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  border-top: 1px solid #D5D5D5;
  padding-top: 32px;

  .attachements {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    column-gap: 64px;
    align-self: stretch;
    padding-bottom: 20px;

    > li {
      display: flex;
      align-items: center;
      gap: 24px;
      flex-wrap: wrap;
      padding: 12px 0;
      border-bottom: 1px solid #D5D5D5;
    
      a {
        font-weight: 400;
        display: flex;
        align-items: center;
        gap: 12px;
        color: $primaryColorFont;

        svg {
          fill: $primaryColorFont;
        }
      }
    }
  }
}

.product-navigation {
  background: $bgColor;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  
  .nav {
    width: 55%;
    position: relative;
    flex: 1;
    user-select: none;

    &__swiper {
      overflow: hidden;
    }

    &__wrapper {
      display: flex;
      flex-direction: row;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      width: 185px;
      justify-content: center;
      height: 52px;
      align-items: center;

      &:hover {
        cursor: pointer;
      }

      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background-color: $primaryColor;
        opacity: 0;
        transform: scaleY(0);
        transform-origin: bottom;
        transition: opacity 0.3s ease, transform 0.3s ease;
        border-radius: 4px;
      }
    
      span {
        font-weight: 400;
        transition: font-weight 0.3s ease;
        margin: 0 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        width: 210px;
        -webkit-box-orient: vertical;
        display: flex;
        justify-content: center;
      }
    
      &:hover span {
        font-weight: 600;
      }

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 24px;
        width: 1px;
        border-right: 1px solid #D9D9D9;
      }
    
      &:last-child::after {
        display: none;
      }
    }
    
    .nav-item-active {
      &::before {
        opacity: 1;
        transform: scaleY(1);
      }
    
      span {
        font-weight: 600;
      }
    }

    &__prev, &__next {
      display: none;
      position: absolute;
      z-index: 90;
      top: 14px;

      svg {
          width: 16px;
          height: 16px;
      }
    }

    .arrow {
      width: 24px;
      height: 24px;
    }

    &__prev {
      left: -36px;

      svg {
          rotate: 180deg;
      }
    }

    &__next {
      right: -36px;
    }
  }

  .product-label {
    margin-left: 8px;
    padding: 8px 0 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    justify-content: space-between;

    flex-shrink: 0;
  
    &__buttons {
      .buttons-group {
        display: flex;
        width: 100%;
      }
    }
  
    &__details {
      display: flex;
      align-items: center;
      gap: 8px;
  
      .image {
        width: 40px;
        height: 40px;
        border-radius: 8px;
  
        img {
          width: 40px;
          height: 40px;
          object-fit: contain;
          border-radius: 4px;
        }
      }
  
      .no-image {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        fill: $labelsColor;
      }
  
      .name-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 4px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        padding-right: 12px;
        
        .name {
          width: 225px;
          overflow:hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
  
  
        span {
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
        }
      }
    }
  
    .primary-action-button {
      display: flex;
      padding: 8px 12px;
      justify-content: center;
      align-items: center;
      width: max-content;
  
      svg {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }
    }
  }
}

.nav-attached-js {
  padding: 0 9%;
  z-index: 998;
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.12);

  .nav {
    margin: 0 48px;
  }
}

.nav-not-attached-js {
  position: relative;
  box-shadow: none;
  margin-top: 24px;

  .nav {
    width: calc(100% - 96px);
    margin: 0;
  }
}

.product-presentation-menu-js {
  transition: 0.2s all;
}

@media screen and (max-width: 1439px) {
  .product-navigation.nav-attached-js {
    flex-wrap: wrap;
    height: 106px;

    &__elements {
      > li {
        flex: 1 0 auto;
        justify-content: center;
        order: 0;
      }
    }

    .product-label {
      order: -1;
      min-width: 100%;
      display: flex;
      justify-content: space-between;
  
      &::before {
        content: none;
      }
  
      &__details {
        .name-container {
          .name {
            max-width: 1000px;
            width: fit-content;
          }
        }
      }
    }
  }

  .nav-attached-js {
      padding: 0 32px;
  }
}

.sets-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  row-gap: 32px;
  border-top: 1px solid #D5D5D5;
  padding: 32px 0;

  .sets-details {
    display: grid;
    grid-template-columns: 75% 21%;
    gap: 48px;

    .sets {
      position: relative;
      user-select: none;
      margin: 16px 32px;

      &__swiper {
        overflow: hidden;

        .mask-left,
        .mask-right {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 100px;
            z-index: 2;
            pointer-events: none;
            background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
            opacity: 1;
            transition: opacity 0.3s ease;
        }

        .mask-left {
            left: 0;
            background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        }

        .mask-right {
            right: 0;
            background: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        }

        .mask-hidden {
            opacity: 0;
        }
      }
  
      &__wrapper {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        width: 220px;
        justify-content: space-between;
        height: auto;
        align-items: flex-start;

        .product-info {
          display: flex;
          width: 190px;
          gap: 16px;
          flex-direction: column;
          align-items: flex-start;

          .flags {
            position: absolute;
            left: 4px;
            top: 4px;

            .tile {
              display: flex;
              padding: 1px 8px;
              align-items: flex-start;
              width: fit-content;
              gap: 10px;
              border-radius: 2px;
              margin-bottom: 4px;
              color: $lightestColorFont;

              &.archival {
                background: #D5D5D5;
              }

              &.free {
                background: $dangerColor;
              }

              &.set-quantity {
                background: $middleColorFont;
              }
            }
          }

          a {
            width: 190px;
            height: 190px;
            outline-offset: -1px !important;
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
              width: 150px;
              height: 190px;
            }
          }
  
          img {
              max-height: 100%;
              width: auto;
              height: auto;
              object-fit: contain;
              border-radius: 4px;
          }

          .name {
            height: 40px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            align-self: flex-start;
            overflow: hidden;
            position: relative;
            word-break: break-word;
            transition: max-height 0.3s ease-out;
          }

          .price-details {
            display: flex;
            gap: 8px;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            align-items: baseline;

            .current-price {
              font-weight: 500;
            }

            .previous-price {
              font-size: 12px;
              line-height: 18px;
              color: $labelsColor;
              text-decoration: line-through;
            }
          }

          .retail-price {
            font-size: 12px;
            line-height: 18px;
            color: $labelsColor;
            text-align: left;
          }

          .set-attribute {

            &-name{
              color: #2e2e2e;
              font-size: 12px;
              font-weight: 500;
              line-height: 16px;
              display: block;
            }

            &-value{
              border-radius: 5px;
              height: 42px;
              padding: 0 16px 0 8px;
              border: 1px solid #4a4a4a;
              font-size: 14px;
              line-height: 20px;
              max-width: 150px;
            }
          }

          .select {
            &__input {
              .selected-js {
                margin-right: 10px;
                width: 200px;
                white-space: nowrap;
                font-size: 14px;
                line-height: 20px;
                text-overflow: ellipsis;
              }
            }
          }


          .form {
            &__input-info {
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              white-space: normal;
              max-width: 170px;
            }
          }

          .pure-button {
            align-self: center;
          }

          .expand-attributes {
            width: inherit;

            .form__input-wrapper {
              &:first-child {
                margin-top: 8px;
              }
            }
          }

          .set-product-supplies {
            width: inherit;

            .select {
              &__input {
                padding-top: 2px;
                .selected-js {
                  width: auto;
                }
              }
            }
          }
        }

        &:last-child {
          display: block;
          width: 190px;
        }
      }
  
      &__plus {
        display: flex;
        margin: 90px 0 auto;
  
        .plus-icon {
          width: 24px;
          height: 24px;
          fill: #959595;
        }
      }
  
      &__prev, &__next {
          position: absolute;
          z-index: 90;
          top: 80px;
  
          svg {
              width: 16px;
              height: 16px;
          }
      }
  
      &__prev {
          left: -24px;
  
          svg {
              rotate: 180deg;
          }
      }
  
      &__next {
          right: -24px;
      }

      &__price-details {
        display: flex;
        align-items: flex-start;
        gap: 24px;
        flex-direction: column;

        .prices {
          display: flex;
          gap: 16px;
          flex-direction: column;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;

          .main-price {
            display: flex;
            gap: 4px;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
          }
  
          .previous-price, 
          .deposit-price {
            display: flex;
            gap: 4px;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            color: $labelsColor;
  
            .value {
              text-decoration: line-through;
            }

            .suggested-price {
              width: 16px;
              height: 16px;
              fill: $labelsColor;
            }
          }

          .saved {
            display: flex;
            padding: 2px 8px;
            justify-content: center;
            align-items: flex-start;
            gap: 10px;
            border-radius: 4px;
            border: 1px solid $successColor;
            color: $successColor;
            width: max-content;
          }
        }

        .primary-action-button {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
          width: 100%;

          svg {
            flex-shrink: 0;
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }

  .hidden-set-prices {
    grid-template-columns: 100%;
    justify-content: center;
  }
}

.related-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  row-gap: 32px;
  border-top: 1px solid #D5D5D5;
  padding: 32px 0;

  .related-details {
    display: block;

    .related {
      position: relative;
      user-select: none;
      margin: 16px 32px;

      &__swiper {
        overflow: hidden;

        .mask-left,
        .mask-right {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 100px;
            z-index: 2;
            pointer-events: none;
            background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
            opacity: 1;
            transition: opacity 0.3s ease;
        }

        .mask-left {
            left: 0;
            background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        }

        .mask-right {
            right: 0;
            background: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
        }

        .mask-hidden {
            opacity: 0;
        }
      }
  
      &__wrapper {
        display: flex;
        flex-direction: row;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        width: calc(100% / 4);
        justify-content: space-between;
        align-items: flex-start;

        .related-product {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          height: 460px;
          row-gap: 16px;
          margin: 0 auto;
          background-color: #ffffff;
          overflow: hidden;
          position: relative;
      
          &__flags {
            position: absolute;
            left: 4px;
            top: 4px;
          }
      
          &__image {
              display: flex;
              width: 100%;
              height: 270px;
              justify-content: center;
              align-items: center;
      
              img {
                  object-fit: contain;
                  max-width: 100%;
                  max-height: 100%;
                  border-radius: 8px;
              }
          }
      
          &__remove {
              display: flex;
              position: absolute;
              width: 16px;
              height: 16px;
              top: 5%;
              right: 5%;
              border: none;
              background-color: transparent;
              flex-wrap: nowrap;
              align-content: center;
              justify-content: center;
              align-items: center;
              cursor: pointer;
              padding: 0;
      
              svg {
                  fill: #959595;
              }
          }
      
          &__info {
            display: flex;
            width: 100%;
            min-height: 100px;
            justify-content: space-between;
            flex-direction: column;
      
            &-group {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }
          }

          &__suggested {
            @include body-2-regular;
            color: #767676;
            height: 16px;
          }
      
          &__name {
              color: $primaryColorFont;
              @include body-1-regular;
              text-decoration: none;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
          }
      
          &__prices {
            display: flex;
            gap: 8px;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            align-items: baseline;
          }

          &__price-deposit {
            @include body-2-regular;
            color: $labelsColor;
          }
      
          &__price {
              &-current {
                  @include body-1-semi-bold;
              }
      
              &-previous {
                font-size: 12px;
                line-height: 18px;
                color: $labelsColor;
                text-decoration: line-through;
              }
      
              &-tax {
                  @include body-1-regular;
              }
      
              &-lowest {
                  @include body-2-regular;
                  color: $labelsColor;
              }
          }
      
          &__buttons {
            display: flex;
            width: 100%;
            justify-content: space-between;

            .buttons-group {
              display: flex;
              width: 100%;
              gap: 8px;
              
              .primary-action-button {
                width: inherit;
                padding: 8px 4px;
              }

              .secondary-action-button {
                width: 40px;
                padding: 0;
              }
            }

            a {
              width: inherit;
            }
          }
        }
      }
  
      &__prev, &__next {
          position: absolute;
          z-index: 90;
          top: 110px;
  
          svg {
              width: 16px;
              height: 16px;
          }
      }
  
      &__prev {
          left: -24px;
  
          svg {
              rotate: 180deg;
          }
      }

      &__next {
          right: -24px;
      }
    }
  }
}

.tile {
  display: flex;
  padding: 1px 8px;
  align-items: flex-start;
  width: fit-content;
  gap: 10px;
  border-radius: 2px;
  margin-bottom: 4px;
  color: $lightestColorFont;

  &.archival {
    background: #D5D5D5;
  }

  &.Promotion,.Free {
    background: $ribbonPromotion;
  }

  &.BestRated {
    background: $ribbonBestRated;
  }

  &.NewProduct {
    background: $ribbonNewProduct;
  }

  &.PromotionalProduct {
    background: $ribbonPromotionalProduct;
  }

  &.RecommendedProduct {
    background: $ribbonRecommendedProduct;
  }

  &.VendorRecomendation {
    background: $ribbonVendorRecomendation;
  }

  &.GreatPrice {
    background: $ribbonGreatPrice;
  }

  &.GreatQuality {
    background: $ribbonGreatQuality;
  }

  &.Sale {
    background: $ribbonSale;
  }

  &.Reward {
    background: $ribbonReward;
  }
}

.sizeChart {
  max-height: 548px;
  width: 700px;

  .dialog__content {
    padding: 24px 32px 32px 32px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: auto;

    .bannerItemContainer {
      .bannerHeading {
        margin: 24px 0;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
      }

      .imgContainer {
        display: block;

        &--image {
          max-width: 100%;
          height: auto;

          &.table, &.contour {
            margin: auto;
            display: block;
          }
        }
      }
      &:first-child {
        .bannerHeading {
          margin: 0 0 24px;
        }
      }
    }
  }
}

.coupons-on-product-presentation {
  margin-bottom: 16px;
  cursor: pointer;
  
  .product-coupons-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .product-coupons-items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;

    .product-coupon-item {
      flex: 0 0 calc(50% - 4px);
      padding: 0 8px;
      border: 1px solid $secondaryBtnBorderColor;
      background-color: $secondaryBtnBgColor;
      border-radius: 6px;
      margin-bottom: 0;
      min-height: 40px;
      
  
      .coupon-icon-container {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: $bgColor;
          border: none;

          .coupon-icon-js {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            .coupon-icon-svg {
              width: 100%;
              height: 100%;
              fill: $secondaryBtnFontColor;
            }
          }

          &:hover {
            .coupon-icon-svg {
              fill: $secondaryBtnHoverFontColor;
            }
          }
      }

      .coupon-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
        
        .coupon-name {
          @include body-2-regular;
          color: #333;
          flex: 1;
        }
        
        .coupon-discount {
          font-weight: 700;
          color: #28a745;
          margin: 0 12px;
        }
        
        .coupon-validity {
          @include body-2-regular;
          color: #666;
        }
      }
    }
  }
}


`